<template>
  <div id="app">
    <div v-if="$readOnly" class="read-only-banner">
      This is a read-only archive of the old Ship242 system. Ship242 has moved —
      customers: <a href="https://app.ship242.com">app.ship242.com</a> ·
      staff: <a href="https://admin.ship242.com">admin.ship242.com</a>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      
    }
  }
}
</script>

<style lang="scss">
.read-only-banner {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  padding: 10px 16px;
  background: #fff3cd;
  color: #664d03;
  font-size: 0.95rem;
  text-align: center;

  a {
    color: #664d03;
    font-weight: 600;
  }
}
</style>
